import {Checkbox, Col, Form, Row} from "antd";
import {useEffect, useState} from "react";
import {CustomerDetailWrapperDto} from "../../../dto/admin/CustomerDetailWrapperDto";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";


interface CustomerVerificationInformationProps {
    customerDetailWrapperDto: CustomerDetailWrapperDto
}

const CustomerVerificationInformation = (props: CustomerVerificationInformationProps) => {
    const [form] = Form.useForm();
    const [ceoApproval, setCeoApproval] = useState<boolean>(false);
    const [coApproval, setCoApproval] = useState<boolean>(false);

    useEffect(() => {
        setCustomerVerificationStatuses()
    }, []);
    const setCustomerVerificationStatuses = () => {
        let adminWorkBasketDto: WorkbasketTableDto = props.customerDetailWrapperDto.adminWorkBasketDto;
        if (adminWorkBasketDto) {
            setCeoApproval(getBooleanByStatus(adminWorkBasketDto.ceoApproval))
            setCoApproval(getBooleanByStatus(adminWorkBasketDto.complianceOfficerApproval))
        }
    }


    const getBooleanByStatus = (approval: string | undefined): boolean => {
        if (undefined !== approval) {
            return "Yes" == approval ? true: false;
        }
        return false;
    }


    return (
        <div>
            <Form
                className='form-input'
                layout={"vertical"}
                initialValues={{remember: true}}
                form={form}
                diabled={true}
            >
                <Row>
                    <Col xxl={12} xl={12} lg={12} className='margin_bottom_upload_button'>

                        <div className={'margin_top_20 checked-disabled-checkboxes admin-approval-checkboxes'}>
                            <Form.Item
                                name={"ceoApproval"}
                                label="">
                                <Checkbox disabled checked={ceoApproval}>
                                    <h4 className='account-create-form-subheader'
                                        style={{marginBottom: 0}}>CEO
                                        Approval</h4></Checkbox>
                            </Form.Item>
                            <Form.Item
                                name={"coApproval"}
                                label="">
                                <Checkbox disabled checked={coApproval}>
                                    <h4
                                        className='account-create-form-subheader'
                                        style={{marginBottom: 0}}>Compliance
                                        Officer Approval</h4></Checkbox>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>

            </Form>
        </div>
    )
}
export default CustomerVerificationInformation